module.exports = __webpack_public_path__ + "img/GamesCom1.69a94f79.jpg";